import http from "../utility/http";

/**
 * Portal typeahead: `GET /v1/search/{category}` (Algolia for most categories; MySQL for `prescribers` + `cities`).
 * Partner onboarding: Step 2 — `GET /partner/v1/search/{category}` (same path after prefix).
 * @see portal-be `src/partner-api/docs/onboarding-spec.ts` and `src/application/search/routes/search.ts`
 */
const Search = async (
  category,
  query,
  limit,
  page = 1,
  sortBy = "id",
  sortOrder = "asc",
  withTotal = false,
  branchId = null,
  stateId = null
) => {
  const branchIdParam = branchId ? `&branchId=${branchId}` : "";
  const stateIdParam =
    stateId != null && stateId !== "" ? `&stateId=${stateId}` : "";

  if (withTotal) {
    return await http.getBackgroundRequest(
      `/v1/search/${category}?fromPortal=true&q=${query || ""}&limit=${
        limit || 50
      }&page=${page || 1}&sortBy=${sortBy || "id"}&sortOrder=${
        sortOrder || "asc"
      }${branchIdParam}${stateIdParam}`
    );
  }
  return await http.getBackgroundRequest(
    `/v1/search/${category}?fromPortal=true&q=${query || ""}&limit=${
      limit || 50
    }${branchIdParam}${stateIdParam}`
  );
};

const SearchProductLocator = async (pharmacyId, drugId, quantity) => {
  return await http.getBackgroundRequest(`/v1/search/product-locator?pharmacyId=${pharmacyId}&drugId=${drugId}&quantity=${quantity}`);
};

const api = {
  Search,
  SearchProductLocator,
};

export default api;
